import {Spinner} from 'shamrock-clover-ui';
import React from 'react';
import css from './styles/fallback.scss';

export default function Fallback() {
  return (
    <>
      <div className={css.loadingContainer}>
        <Spinner color='#0091ea' size='100' />
      </div>
    </>
  );
}
